import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const SchemaEmptyState = {
  schemas: [],
  selectedSchema: null,
};

export const SchemaKey = 'schemas';

export const schemasSlice = createSlice({
  name: 'schemas',
  initialState: getLocalStorage(LocalStorageTypes.SCHEMAS)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.SCHEMAS))
    : SchemaEmptyState,
  reducers: {
    setSchemas: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.SCHEMAS, result);
      return { ...state, ...action.payload };
    },
    updateSelectedSchema: (state, action) => {
      const result = { ...state, selectedSchema: action.payload };
      persistLocalStorage(SchemaKey, result);
      return result;
    },
    resetSchemas: () => {
      clearLocalStorage('schemas');
      return SchemaEmptyState;
    },
  },
});

export const { setSchemas, updateSelectedSchema, resetSchemas } =
  schemasSlice.actions;
